import { Modal } from '@material-ui/core'
import { GetProfileResponseDto } from '@shared/core/users'
import { Widget } from '@typeform/embed-react'
import classes from './shopify-wordpress-survey-modal.module.scss'

export interface ShopifyWordpressSurveyModalProps {
  open: boolean
  onClose: () => void
  profile: GetProfileResponseDto
}

/**
 * Typeform `NzuoyzlO` declares `first_name` and `last_name` as separate hidden
 * fields, but the profile only carries `full_name`. Split on the first space:
 * everything before it is the first name, the remainder is the last name.
 */
function splitFullName(fullName?: string | null): { firstName: string; lastName: string } {
  const trimmed = (fullName ?? '').trim()
  if (trimmed === '') {
    return { firstName: '', lastName: '' }
  }

  const separatorIndex = trimmed.indexOf(' ')
  if (separatorIndex === -1) {
    return { firstName: trimmed, lastName: '' }
  }

  return {
    firstName: trimmed.slice(0, separatorIndex),
    lastName: trimmed.slice(separatorIndex + 1).trim(),
  }
}

export function ShopifyWordpressSurveyModal({ open, onClose, profile }: ShopifyWordpressSurveyModalProps) {
  if (!open) {
    return null
  }

  const { firstName, lastName } = splitFullName(profile.full_name)

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div className={classes.modalBox}>
        <button type="button" className={classes.closeButton} onClick={onClose}>
          <svg className={classes.closeIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#0F1729"
            />
          </svg>
        </button>
        <div className={classes.widgetContainer}>
          <Widget
            id="NzuoyzlO"
            style={{ width: '100%', height: '100%' }}
            hidden={{
              user_id: profile.id,
              email: profile.email,
              first_name: firstName,
              last_name: lastName,
            }}
          />
        </div>
      </div>
    </Modal>
  )
}
